
<template>
  <v-layout column>
    <v-flex xs11 offset-xs0>
      <panel v-bind:title="title">
      
        <PersonEdit v-if ='$store.state.isEditor' v-bind:person="person" slot="action" @onUpdate="onUpdate"/> 
        <div slot="top">

    <template v-if="mugshot">
      <div style='position:absolute;top:70px;left:calc(100% - 150px);margin:10px;border:1px solid #aaaaaa;padding:5px' v-html="mugshot">
      </div>

    </template>

    <v-container grid-list-md text-xs-left mt-2 pl-4 >
      <v-layout row wrap>

        <template v-if="person.otherNames">
          <v-flex xs2>Other names</v-flex>
          <v-flex xs10>
            <div v-for="other in person.otherNames" v-bind:key="other.suranme">
              {{ $prettyName(other.firstNames) }} {{ $prettyName(other.surname) }}  <span v-html="$formatScope(other)"></span>           
           </div>
          </v-flex> 
        </template>

        <template v-if="person.gender">
          <v-flex xs2 >Gender</v-flex>
          <v-flex xs10><span v-html="$renderCodeListWithLink(person.gender, 'ge', 'Gender')"/></v-flex>  
        </template>        

        <template v-if="person.service || person.servicenum">
          <v-flex xs2 >Service and Number</v-flex>
          <v-flex xs10>{{ $renderSingleValues(person.service) }}: {{ $renderStandardListNoLink(person.serviceNum) }}
          </v-flex>
        </template>

        <template v-if="person.birthDate || person.birthPlace">
          <v-flex xs2>Born</v-flex>
          <v-flex xs10>
            <span v-if="person.birthDate" v-html="$dateFormatFromYMD(person.birthDate)"/>
            <!-- span v-if="person.birthPlace" v-html="$placeSummary(person.birthPlace)"/ -->
            <place-summary v-if="person.birthPlace" v-bind:place="person.birthPlace"></place-summary>
          </v-flex>
        </template>

        <template v-if="person.occupation">
          <v-flex xs2>Occupation</v-flex>
          <v-flex xs10><span v-html="$renderCodeListWithLink(person.occupation, 'oc', 'Occupation')"/></v-flex>  
        </template>

        <template v-if="person.maritalStatus">
          <v-flex xs2>Marital Status</v-flex>
          <v-flex xs10><span v-html="$renderCodeListWithLink(person.maritalStatus, 'ms', 'Marital Status')"/></v-flex>          
        </template>

        <template v-if="person.nok">
          <v-flex xs2>Next of Kin</v-flex>
          <v-flex xs10>
            <render-noks v-bind:noks="person.nok"></render-noks>
          </v-flex>
        </template>        

        <template v-if="person.religion">
          <v-flex xs2>Religion</v-flex>
          <v-flex xs10><span v-html="$renderCodeListWithLink(person.religion, 'fth', 'Religion')"/></v-flex> 
        </template> 

        <template v-if="person.height">
          <v-flex xs2>Height</v-flex>
          <v-flex xs10>{{ $renderHeight(person.height[0].v) }}</v-flex>  
        </template>        

        <template v-if="person.weight">
          <v-flex xs2>Weight</v-flex>
          <v-flex xs10>{{ $renderWeight(person.weight[0].v) }}</v-flex>  
        </template>  

        <template v-if="person.eyeColour">
          <v-flex xs2>Eyes</v-flex>
          <v-flex xs10><span v-html="$renderCodeListWithLink(person.eyeColour, 'ec', 'Eye Colour')"/></v-flex> 
        </template>         

        <template v-if="person.hairColour">
          <v-flex xs2>Hair</v-flex>
          <v-flex xs10><span v-html="$renderCodeListWithLink(person.hairColour, 'hc', 'Hair Colour')"/></v-flex> 
        </template>
       
        <!-- removed kkf 8sep19 template v-if="person.enlistDate || person.enlistmentPlace">
          <v-flex xs2>Enlisted (DVA)</v-flex>
          <v-flex xs10>
            <span v-if="person.enlistDate" v-html="$dateFormatFromYMD(person.enlistDate)"/>
            <place-summary v-if="person.enlistmentPlace" v-bind:place="person.enlistmentPlace"></place-summary>            
          </v-flex>
        </template -->

        <template v-if="person.addressAtEnlistment">
          <v-flex xs2>Address at Enlistment</v-flex>
          <v-flex xs10>
            <place-summary v-bind:place="person.addressAtEnlistment"></place-summary>
            <!-- span v-html="$placeSummary(person.addressAtEnlistment)"/ -->
          </v-flex>
        </template>

        <template v-if="person.rank">
          <v-flex xs2>Final Rank</v-flex>
          <v-flex xs10>
            <list-with-links v-bind:field="person.rank" fieldName="rank"></list-with-links>
          </v-flex>
        </template>

        <template v-if="person.homePort">
          <v-flex xs2>Home Port</v-flex>
          <v-flex xs10>
            <place-summary v-bind:place="person.homePort"></place-summary>
            <!-- span v-html="$placeSummary(person.homePort)"/ -->
          </v-flex>
        </template>

        <template v-if="person.unit">
          <v-flex xs2 >Final Unit</v-flex>
          <v-flex xs10>
              <list-with-links v-bind:field="person.unit" fieldName="unit"></list-with-links>

           <!-- span v-html="$renderStandardListWithLink(person.unit, 'unit')"></span -->
          </v-flex>  
        </template>

        <!-- now part of render NOK
        <template v-if="person.NOKPlace">
          <v-flex xs2>Next of Kin Address</v-flex>
          <v-flex xs10>
            <span v-html="$placeSummary(person.NOKPlace)"/></v-flex>
        </template>        
        -->

        <!-- too hard for now - NOK are just props for now, not people...
        <template v-if="person.nokFor">
          <v-flex xs2>Next of kin for</v-flex>
          <v-flex xs10 v-html="$renderNoksFor(person.nokFor)"/>
        </template>
        -->

        <!-- MOVED TO SERVICE REC template v-if="person.honour">
          <v-flex xs2>Honours</v-flex>
          <v-flex xs10>
              <v-flex xs10><span v-html="$renderCodeListWithLink(person.honour, 'aw', 'Honour')"/></v-flex>
          </v-flex>
        </template -->

        <template v-if="person.servicePlace">
          <v-flex xs2>Service Location Summary</v-flex>
          <v-flex xs10>
            <div v-for="sp in person.servicePlace" v-bind:key="sp.id">
                  <ShowServicePlace v-bind:sp='sp'/>
            </div>
          </v-flex>
        </template> 

        <template v-if="person.servicePeriod || person.serviceDays">
          <!-- was 4aug22 v-flex xs2>Service Period Summary</v-flex -->
          <v-flex xs2>Served on continuous Full Time War Service in the</v-flex>
          <v-flex xs10>
            <div v-for="sp in person.servicePeriod" v-bind:key="sp.id">
                  <ShowServicePeriod v-bind:sp='sp'/>
            </div>
            <div v-for="sp in person.serviceDays" v-bind:key="sp.id">
                  <ShowServiceDays v-bind:sp='sp'/>
            </div>            
          </v-flex>
        </template>  

        <template v-if="person.bio">
          <v-flex xs2>Service History</v-flex>
          <v-flex xs10>
            <template v-if="Array.isArray(person.bio)">
                <div v-for="bio in person.bio" v-bind:key="bio.id">
                  <ShowBio v-bind:bio='bio' v-bind:person='person'/>
                </div>                  
            </template>
            <template v-else>
               <ShowBio v-bind:bio='person.bio' v-bind:person='person'/>
            </template>
          </v-flex>
        </template>  

        <!-- moved to bio: template v-if="person.dischargeDate">
         <v-flex xs2>Discharged</v-flex>
          <v-flex xs10>{{ $dateFormatFromYMD(person.dischargeDate) }}</v-flex>
        </template -->

        <template v-if="person.returnToAustraliaDate">
         <v-flex xs2>Returned to Australia</v-flex>
          <v-flex xs10>{{ $dateFormatFromYMD(person.returnToAustraliaDate) }}</v-flex>
        </template>
     
        <template v-if="person.fate">
          <v-flex xs2>Fate</v-flex>
          <v-flex xs10><span v-html="$renderCodeListWithLink(person.fate, 'ft', 'Fate')"/></v-flex> 
        </template>
        <template v-if="person.fatePostWar">
          <v-flex xs2>Fate post war</v-flex>
          <v-flex xs10><span v-html="$renderCodeListWithLink(person.fatePostWar, 'ftp', 'Fate post war')"/></v-flex> 
        </template>        
     
        <template v-if="person.pow">
          <v-flex xs2>Prisoner of War</v-flex>
          <v-flex xs10>Yes</v-flex> 
        </template>
        
        <template v-if="person.noteFamily">
          <v-flex xs2>Family Notes</v-flex>
          <v-flex xs10><list-no-links v-bind:field="person.noteFamily" v-bind:fieldToRender="'v'"/></v-flex>
        </template>        

        <template v-if="person.honourRollPlace">
          <v-flex xs2>Honour Roll Place</v-flex>
          <v-flex xs10>
            <place-summary v-bind:place="person.honourRollPlace"></place-summary>
            <!-- span v-html="$placeSummary(person.honourRollPlace)"/ -->
          </v-flex>
        </template>

        <template v-if="person.awmHonourRollPanel">
          <v-flex xs2>AWM Roll of Honour Panel</v-flex>
          <v-flex xs10>{{ $renderSingleValues(person.awmHonourRollPanel) }} </v-flex>
        </template>         

        <template v-if="person.deathDate">
          <v-flex xs2>Died</v-flex>
          <v-flex xs10>{{ $dateFormatFromYMD(person.deathDate) }}</v-flex>         
        </template>

        <template v-if="person.ageAtDeath">
          <v-flex xs2>Age at death</v-flex>
          <v-flex xs10>{{ $renderSingleValues(person.ageAtDeath) }}</v-flex>  
        </template>
        
        <template v-if="person.burial">
          <v-flex xs2>Place of burial or commemoration</v-flex>
          <v-flex xs10>
            <div v-for="burial in person.burial" v-bind:key="burial.rid">
              <template v-if="burial.graveRef">Grave reference:  {{ burial.graveRef }}, </template>
              <template v-if="burial.cemetery">
                <router-link :to="{path: '/cemetery/' + burial.cemetery.id}">{{ burial.cemetery.name }}</router-link>,
                <template v-if="burial.cemetery.place && burial.cemetery.place.town"> {{ burial.cemetery.place.town.v }},</template>
                <template v-if="burial.cemetery.place && burial.cemetery.place.state"> {{ burial.cemetery.place.state.v }},</template>
                <template v-if="burial.cemetery.place && burial.cemetery.place.country"> {{ burial.cemetery.place.country.v }}</template>
              </template> 
            </div>
          </v-flex>
        </template>  

        <template v-if="person.naaLink">
          <v-flex xs2>National Archives Files</v-flex>
          <v-flex xs10>
            <div v-for="naa in person.naaLink" v-bind:key="naa.barcode">
              Series {{ naa.series }}: {{ $decodeNAAseries(naa.series) }}, 
              barcode:  {{ naa.barcode }}
              <template v-if="naa.type === 'no'">(not yet digitised)</template>

              <template v-else>                 
                  <template v-if="naa.description"> "{{naa.description}}" </template> 
                  <template v-if="naa.type != 'record'">{{naa.type}} </template>
                  <a v-bind:href='"https://recordsearch.naa.gov.au/SearchNRetrieve/Interface/ViewImage.aspx?B=" + naa.barcode' >
                      (digitised) </a> 
              </template>
            </div>
          </v-flex>
        </template>

        <template v-if="person.link">
          <v-flex xs2>Other Links</v-flex>
          <v-flex xs10>
            <div v-for="link in person.link" v-bind:key="link.id">              
                <template v-if="link.description"> {{link.description}} </template> 
                <a v-bind:href='link.url'>
                   <template v-if="link.url.indexOf('https://connect.dva.gov.au/commemsoawg/commemoration/viewPhoto.html?fileId') == 0">
                    <img v-bind:src='link.url' width='200'>
                    <BR/>
                  </template>
                  {{link.prompt}}                 
                </a> 
            </div>
          </v-flex>
        </template>        

        <template v-if="person.image">
          <v-flex xs2>Images</v-flex>
          <v-flex xs10>
            <template v-if="Array.isArray(person.image)">
                <div v-for="image in person.image" v-bind:key="image.id">
                  <div style='float:left;margin-left:20px' v-html="$renderSmallImage(image)"/>
                  <!-- small-image v-bind:image="image"/ -->
                </div>
            </template>
            <template v-else>
               <div style='float:left;margin-left:20px' v-html="$renderSmallImage(person.image)"/>
            </template>
          </v-flex>
        </template>

        <template v-if="person.note">
          <v-flex xs2>General Notes</v-flex>
          <v-flex xs10><list-no-links v-bind:field="person.note" v-bind:fieldToRender="'v'"/></v-flex>
        </template>                   

        <template v-if="person.noteCwgMatch">
          <v-flex xs2>CWG Match Notes</v-flex>
          <v-flex xs10><list-no-links v-bind:field="person.noteCwgMatch" v-bind:fieldToRender="'v'"/></v-flex>
        </template>

        <template v-if="person.noteNaamatch">
          <v-flex xs2>NAA Match Notes</v-flex>
          <v-flex xs10><list-no-links v-bind:field="person.noteNaamatch" v-bind:fieldToRender="'v'"/></v-flex>
        </template>        
        <!--
          case 'nts' : p.note = { seq: r.seqnum, v: JSON.stringify(r.tv) } ;  break ;
          case 'ntf' : p.noteFamily = { seq: r.seqnum, v: r.tv } ; break ;
          case 'ntc' : p.noteCwgMatch = { seq: r.seqnum, v: r.tv } ; break ; 
          case 'ntn' : p.noteNaamatch = { seq: r.seqnum, v: r.tv } ; break ;
          -->
        
      </v-layout>
  </v-container>
        </div>
      </panel>
    </v-flex>
  </v-layout>
</template>

<script>

import PeopleService from "@/services/PeopleService" ;
import Panel from "@/components/Panel" ;
import PersonEdit from "./PersonEdit" ;
import ShowBio from "./Person/ShowBio" ;
import ShowServicePlace from "./Person/ShowServicePlace" ;
import ShowServicePeriod from "./Person/ShowServicePeriod" ;
import ShowServiceDays from "./Person/ShowServiceDays" ;

export default {
  components: {
    Panel, PersonEdit, ShowBio, ShowServicePlace, ShowServicePeriod, ShowServiceDays
  },
  data () {
    return {
      id: '',
      person: {},
      error: null,
      title: "Loading Person " + this.$route.params.id,
      mugshot: ''
    }
  },
  async created () {
    // console.log("in person created") ;
    // await this.$getCodes() ;  // needed for everything - make sure we have them and they are up to date
    // console.log("exit person created") ;
  },
  async mounted () {
    console.log("in person mounted") ;
    this.id = this.$route.params.id ;
    console.log("route parm id " + this.$route.params.id) ;
    console.log("store route parm id " + this.$store.state.route.params.id) ;
    console.log(" MAKE SURE CODES are up to date") ;
    await this.$getCodes() ;  // needed for everything - make sure we have them and they are up to date
    console.log(" BACK FROM CODE GET") ;
    await this.readData() ;
  },
  watch: {
    person: function () {
      console.log("PERSON WATCH invoked") ;
      this.setMugShot() ;
    }
  },
  methods: {

    setMugShot () {
      let newMugshot = '' ;
      if (this.person && this.person.image) {
        let selectedImage = null ;
        if (Array.isArray(this.person.image)) {
          for (const img of this.person.image) {
            if (img.type === "identity photo") {
              selectedImage = img ;
              break ;
            }
          }
        }
        else if (this.person.image.type === "identity photo") selectedImage = this.person.image ;

        if (selectedImage) {
          var js = 'var t=document.getElementById("theimg").style.display;' +
          'if (t != "none") { document.getElementById("theimg").style.display="none";document.getElementById("imgTog").innerHTML ="Show identity photo";}' +
          'else {document.getElementById("theimg").style.display="block";document.getElementById("imgTog").innerHTML="HIDE";}' ;

          newMugshot = "<div style='float:right;cursor:pointer' onclick='" + js + "' >[ <span id='imgTog'>HIDE</span> ]</div>" +
            "<div id='theimg'><a href='" + this.$imageBaseURL + selectedImage.filename + "'>" +
            "<img src='" + this.$imageBaseURL + selectedImage.filename + "' style='width:100px'/>" +
            "</a><div>" ;
        }        
      }
      if (newMugshot !== this.mugshot) this.mugshot = newMugshot ;
      // console.log("Set mugshot " + this.mugshot) ;          
    },

    async readData () {

      const result = await PeopleService.id(this.id) ;
      this.sortFields(result.data) ;
      this.person = result.data ;
      this.setTitle() ; 
      console.log(JSON.stringify(this.person)) ;
        
    },
    onUpdate (updatedPerson) {
      console.log("onUpdate invoked with updatedPerson=" + JSON.stringify(updatedPerson)) ;
      this.sortFields(updatedPerson) ;
      this.person = updatedPerson ;
      this.setTitle() ;
      // this.$forceUpdate() ;
    },
    setTitle () {
      this.title = this.$prettyName(this.person.firstNames) + " " + this.$prettyName(this.person.surname) ;
    },
    sortFields (p) {
      console.log("othernames=" + JSON.stringify(p.otherNames)) ;
      for (var fld in p) {
        const f = p[fld] ;
        if (Array.isArray(f) && (f.length > 1) && (!f.seq)) this.sortOnSeq(f) ;
      }   
    },
    sortOnSeq (arr) {
      arr.sort(function (a, b) { return (a.seq > b.seq) ? 1 : ((b.seq > a.seq) ? -1 : 0); }) ; 
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Person.vue